var React = require('react');

function Sofa (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.2 8.1c1.7.1 3 1.4 3.2 3.1 0 .3.2.4.5.4H18c.3 0 .5-.2.5-.4.2-1.6 1.5-2.9 3.1-3 .2 0 .4-.2.4-.4v-.2c0-2.5-2-4.5-4.5-4.5h-11C4 3.1 2 5.1 2 7.6v.3c0 .1.1.2.2.2z","key":0}),React.createElement("path",{"d":"M22 9.6c-1.1 0-2 .9-2 2v1c0 .3-.2.5-.5.5h-15c-.3 0-.5-.2-.5-.5v-1c0-1.1-.9-2-2-2s-2 .9-2 2v4c0 1 .6 1.9 1.5 2.3.2.1.3.3.3.5v1.3c0 .7.6 1.2 1.2 1.2s1.2-.6 1.2-1.2v-1c0-.3.2-.5.5-.5h14.5c.3 0 .5.2.5.5v1c0 .7.6 1.2 1.2 1.2s1.2-.6 1.2-1.2v-1.3c0-.2.1-.4.3-.5.9-.4 1.5-1.3 1.5-2.3v-4c.1-1.1-.8-2-1.9-2z","key":1})]);
}

Sofa.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Sofa;

Sofa.default = Sofa;
